import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminUploadPagesListHeader from './ListHeader';
import AdminUploadPagesListItem from './ListItem';

const AdminUploadPagesList = ({
  uploadPages,
  openUploadPageEditModal,
  handleDeleteUploadPage,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list upload-pages-list" responsive>
      <thead>
        <AdminUploadPagesListHeader
          {...props}
        />
      </thead>
      <tbody>
        {uploadPages.map(uploadPage => (
          <AdminUploadPagesListItem
            key={uploadPage.uuid}
            uploadPage={uploadPage}
            handleDeleteUploadPage={handleDeleteUploadPage}
            openUploadPageEditModal={openUploadPageEditModal}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminUploadPagesList.propTypes = {
  uploadPages: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  handleDeleteUploadPage: PropTypes.func.isRequired,
  openUploadPageEditModal: PropTypes.func.isRequired,
};

export default AdminUploadPagesList;
